module.exports = __webpack_public_path__ + "static/media/background.592309de.png";